import { useLazyQuery } from "@apollo/client";
import { CONFIRMED_NOT_SHIPPED_ORDERS } from "../reportTypeDefs";

export const useLazyQueryConfirmedNotShippedOrders = (options?: any) =>
  useLazyQuery(CONFIRMED_NOT_SHIPPED_ORDERS, options);
